import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
const StudyLinkArray = (props) => {
  const { client, id } = useParams();
  return (

    props.data.studies__org_study_id.map((study, index) => {

      return(
        // <div>
        <span>
          <Link to={`/${client}/studies/` + study?.uid}>{study?.org_study_id}</Link>
          {
            props.data.studies__org_study_id[index+1] &&
            <span>, </span>
          }
        </span>

      )
    })
  );
};

export default StudyLinkArray;